<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Hochzeit</h3>
      </div>
    </div>
    <div class="section section-work-images">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-1.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-2.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-3.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-4.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-5.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-6.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-7.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-8.jpg"
            />
          </div>
        </div>
        <!--
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-9.jpg"
            />
          </div>
        </div>
        -->
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-10.jpg"
            />
          </div>
        </div>
        <!--
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-11.jpg"
            />
          </div>
        </div>
        -->
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-12.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-13.jpg"
            />
          </div>
        </div>
        <!--
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-14.jpg"
            />
          </div>
        </div>
        -->
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-15.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-16.jpg"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-10 ml-auto mr-auto">
            <img
              alt="Hochzeit Blumen"
              class="image-container"
              src="img/wedding/wedding-17.jpg"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'wedding',
  bodyClass: 'wedding-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 50px;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
